import classNames from 'classnames';
import type {CSSProperties} from 'react';
import type {ColumnAlignmentType} from './ColumnAlignment';
import * as ColumnAlignment from './ColumnAlignment';
import type {ColumnTypeType} from './ColumnType';
import * as ColumnType from './ColumnType';
import type {ColumnPropType} from './propTypes';

const columnTypeClassNames: { [ColumnTypeType]: string } = {
    [ColumnType.SELECTION]: 'selection',
    [ColumnType.ACTIONS]: 'actions',
};

const columnAlignmentClassNames: { [ColumnAlignmentType]: string } = {
    [ColumnAlignment.CENTER]: 'text-center',
    [ColumnAlignment.RIGHT]: 'text-right',
};

export function getCellClassName(column: ColumnPropType, baseClassName: string, applyAlignment?: boolean = false): string {
    const columnTypeClassName = columnTypeClassNames[column.type];
    const columnAlignmentClassName = applyAlignment && columnAlignmentClassNames[column.alignment];
    return classNames(baseClassName, columnTypeClassName, columnAlignmentClassName) || undefined; // Nechceme vrátit prázdný string
}

export function getCellStyle(column: ColumnPropType, baseStyle?: CSSProperties, width?: number): CSSProperties {
    let style = baseStyle;
    if (width == null) {
        width = column.width;
    }
    if (width != null) {
        style = style ? {...style, width} : {width};
    }
    return style;
}
